const loadEqualWebScript = () => {
  window.interdeal = {
    sitekey: '8c4d55ffb115a5fb7bc4ed4c59fa95c0',
    Position: 'Left',
    Menulang: 'EN',
    domains: {
      js: 'https://aacdn.nagich.com/',
      acc: 'https://access.nagich.com/',
    },
    btnStyle: {
      color: {
        main: '#499a1d',
        second: '#fff',
      },
      vPosition: ['80%', undefined],
      scale: ['0.5', '0.5'],
      icon: {
        type: 11,
        shape: 'circle',
        outline: true,
      },
    },
  }
  ;(function(doc, head, body) {
    const coreCall = doc.createElement('script')
    coreCall.src = 'https://aacdn.nagich.com/core/4.2.1/accessibility.js'
    coreCall.defer = true
    coreCall.integrity =
      'sha512-RoBJzx90QrN0gC7WfhEIJRxInvLiYuAHS4D/f5h5iRt31pElVr2z7MtGOD+XBK0rKq8mjQaic2jX5gzTZ7WGZQ=='
    coreCall.crossOrigin = 'anonymous'
    coreCall.setAttribute('data-cfasync', 'true')
    body ? body.appendChild(coreCall) : head.appendChild(coreCall)
  })(document, document.head, document.body)
}

const isEqualWebScriptLoaded = () => {
  // window.interdeal.a11y.a11yBtn an object the EqualWeb script creates.
  // If it exists, assume the EqualWeb script has been loaded and EqualWeb has been initialized.
  return !!window.interdeal?.a11y?.a11yBtn
}

const showEqualWebWidget = () => {
  if (isEqualWebScriptLoaded()) {
    window.interdeal.a11y.a11yBtn.click()
  }
}

export { loadEqualWebScript, isEqualWebScriptLoaded, showEqualWebWidget }
